import { getAccessToken } from "@/service/line";

export type lineUserData = {
  userId: string;
  displayName: string;
  pictureUrl: string;
};
export class LineLogin {
  private redirectUri: string;
  private accessToken: string;
  //  redirect => getCode => requestLineApi get AccessToken => use AccessToken request user info
  constructor(clientId: string) {
    let uri = "https://access.line.me/oauth2/v2.1/authorize?";
    uri += "response_type=code";
    uri += `&client_id=${clientId}`;
    uri += `&redirect_uri=${document.location.origin}`;
    uri += "&state=abcd";
    uri += "&scope=profile%20openid";
    this.redirectUri = uri;
    this.accessToken = window.localStorage.getItem("lineAccessToken") || "";
  }
  getProfile(): Promise<lineUserData> {
    if (!this.accessToken) {
      const code = this.getCode();

      return getAccessToken({
        code: code,
        redirectUri: document.location.origin,
      }).then(({ data }) => {
        if (data.access_token) {
          window.localStorage.setItem("lineAccessToken", data.access_token);
          this.accessToken = data.access_token;
          return this.requestUserProfile();
        } else {
          return this.redirect();
        }
      });
    } else {
      return this.requestUserProfile();
    }
  }
  private redirect() {
    window.localStorage.removeItem("lineAccessToken");
    window.location.href = this.redirectUri;
  }
  // private getAccessToken(code: string) {
  //   return fetch("https://api.line.me/oauth2/v2.1/token", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/x-www-form-urlencoded" },
  //     body: new URLSearchParams({
  //       grant_type: "authorization_code",
  //       client_id: process.env.VUE_APP_client_id,
  //       client_secret: process.env.VUE_APP_client_secret,
  //       code,
  //       redirect_uri: process.env.VUE_APP_redirectUri,
  //     }),
  //   })
  //     .then((res) => res.json())
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }
  private requestUserProfile() {
    return fetch("https://api.line.me/v2/profile", {
      headers: { Authorization: `Bearer ${this.accessToken}` },
    })
      .then((res) => {
        if (res.status !== 200) throw Error("重新請求");
        return res.json();
      })
      .catch((err) => {
        console.error(err);
        this.redirect();
      });
  }
  private getCode() {
    const url = window.location.search;
    if (!url) {
      this.redirect();
    }
    const urlParams = url
      .replace("?", "")
      .split("&")
      .map((param) => param.split("="))
      .reduce((values: any, [key, value]: any) => {
        values[key] = value;
        return values;
      }, {});
    return urlParams.code;
  }
}
